export const useHreflang = () => {
  const langStore = useLanguageStore()
  const { domain } = useNavigationMenu()
  const { basePath } = useLanguage()
  const route = useRoute()

  const alternates = computed(() => {
    const languages = langStore.value
    if (!languages.length) return []

    const base = basePath(route.path)
    const normalizedBase = base === '' ? '/' : base

    const links = languages.map((lang) => {
      const path = lang.default
        ? normalizedBase
        : `/${lang.code}${normalizedBase === '/' ? '' : normalizedBase}`
      return {
        rel: 'alternate',
        hreflang: lang.code,
        href: `${domain.value}${path}`,
      }
    })

    const mainLang = languages.find(lang => lang.default) || languages[0]
    const xDefaultPath = mainLang?.default
      ? normalizedBase
      : `/${mainLang?.code}${normalizedBase === '/' ? '' : normalizedBase}`

    links.push({
      rel: 'alternate',
      hreflang: 'x-default',
      href: `${domain.value}${xDefaultPath}`,
    })

    return links
  })

  return {
    alternates,
  }
}
